import { createSelector } from "@reduxjs/toolkit";
import { selectActiveWorkspaceId } from "@somewear/auth";

import { selectAllQueuedWorkspaceRadioChannelToggles } from "./workspace.radio.queuedToggles.slice";

export const selectRadioChannelTogglesForActiveWorkspace = createSelector(
	[selectAllQueuedWorkspaceRadioChannelToggles, selectActiveWorkspaceId],
	(radioChannelToggles, workspaceId) => {
		return radioChannelToggles.filter(
			(channelToggle) => channelToggle.workspaceId === workspaceId,
		);
	},
);

// Parameterized selector for any workspace
export const selectRadioChannelTogglesForWorkspace = createSelector(
	[selectAllQueuedWorkspaceRadioChannelToggles, (_state, workspaceId: string) => workspaceId],
	(radioChannelToggles, workspaceId) => {
		return radioChannelToggles.filter(
			(channelToggle) => channelToggle.workspaceId === workspaceId,
		);
	},
);
